import React from "react"
import { TwitterShareButton } from "react-share"
import styled from "@emotion/styled"
import { css } from "@emotion/core"
import t, { mixin } from "theme"

// code

const InlineTweet = ({ shortText, tweetMessage, pageUrl }) => {
    return (
        <InlineTweetQuote url={pageUrl} title={tweetMessage + "\n\n"}>
            <span>
                {shortText}
                <InlineTweetButton className="icon-twitter" />
            </span>
        </InlineTweetQuote>
    )
}

export default InlineTweet

// Styling

const InlineTweetQuote = styled(TwitterShareButton)`
    display: inline;
    cursor: pointer;
    font-weight: ${t.font.weight.semibold};
    color: ${t.color.primary};
    ${mixin.chunkyUnderline(t.color.light, 0.3, 0)}
`

const InlineTweetButton = styled("i")`
    vertical-align: middle;
    padding-left: ${t.space[1]};
    font-size: ${t.font.size[8]};
    color: ${t.color.primary};
`
